import Dropdown from 'rsuite/Dropdown';
import 'rsuite/Dropdown/styles/index.css';

export default function ThemeModeProvider({
    handleChangeTheme
}){
    return(
        <>
            <style type={'text/css'}>
                {`
                    #theme{
                        width : calc(1.5em + 1.55rem + 2px);
                    }
                `}
            </style>
            <Dropdown
                title=""
                className={'mb-2'}
                icon={<><i className="ki-outline ki-night-day theme-light-show fs-2"></i>
                          <i className="ki-outline ki-moon theme-dark-show fs-2"></i></>}
                trigger={['click', 'hover']}
                noCaret={true}
                toggleClassName={'ms-4 bg-body text-gray-600'}
                id={'theme'}
                placement={'bottomEnd'}
                menuStyle={{
                    paddingRight : "0.75rem",
                    paddingLeft : "0.75rem"
                }}
            >
                <Dropdown.Item onSelect={() => handleChangeTheme('light')} icon={<i className="ki-outline ki-night-day fs-2"></i>}>
                     <span className="menu-title fs-base">
                         Claro
                     </span>
                </Dropdown.Item>
                <Dropdown.Item onSelect={() => handleChangeTheme('dark')} icon={<i className="ki-outline ki-moon fs-2"></i>}>
                     <span className="menu-title fs-base">
                         Obscuro
                     </span>
                </Dropdown.Item>
                <Dropdown.Item onSelect={() => handleChangeTheme('sistema')} icon={<i className="ki-outline ki-screen fs-2"></i>}>
                     <span className="menu-title fs-base">
                         Sistema
                     </span>
                </Dropdown.Item>
            </Dropdown>
        </>
    );
}
